// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"f87a9fbb","324":"59aae785","343":"db42daee","529":"5caeef4e","699":"c9a96d73","820":"7467fcca"}[chunkId] + ".chunk.css";
};